"use client";

import { ArrowRight, Star, Shield, Clock, Award, Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  return <section data-section-id="255554" id="service-details" className="relative w-full min-h-screen flex items-center justify-start bg-cover bg-center !bg-[url('https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/06/geodetic_surveying_site.jpg')] bg-background text-sidebar-accent">
      {}
      <div className="absolute inset-0 bg-primary/20 backdrop-blur-[2px]" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20">
        {}
        <div className="max-w-2xl">
          <h1 className="font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 md:mb-6 text-sidebar-primary">
            Բարձր Ճշգրտության Գեոդեզիական Աշխատանքներ
          </h1>

          <p className="font-default text-base sm:text-lg text-primary/90 leading-relaxed mb-8 md:mb-10">
            Մենք տրամադրում ենք պրոֆեսիոնալ չափագրման ծառայություններ՝ օգտագործելով ժամանակակից GNSS և տախեոմետրիկ սարքավորումներ։ Ապահովում ենք միջազգային ստանդարտներին համապատասխան ճշգրտություն։
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 md:mb-16">
            <Link to="/GeodeticWorksPage">
              
            </Link>

            
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background/80 to-transparent z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
          <div className="flex flex-wrap gap-3 md:gap-4 justify-center md:justify-start">
            {}
            

            {}
            <div className="flex items-center gap-2 bg-card/80 backdrop-blur-sm px-4 py-2 rounded-md border border-border shadow-sm">
              <Shield size={16} className="text-primary" />
              <span className="text-foreground text-sm font-default font-medium">Լիցենզավորված Մասնագետներ</span>
            </div>

            {}
            <div className="flex items-center gap-2 bg-card/80 backdrop-blur-sm px-4 py-2 rounded-md border border-border shadow-sm">
              <Clock size={16} className="text-primary" />
              <span className="text-foreground text-sm font-default font-medium">Արագ Կատարում</span>
            </div>

            {}
            <div className="flex items-center gap-2 bg-card/80 backdrop-blur-sm px-4 py-2 rounded-md border border-border shadow-sm">
              <Award size={16} className="text-primary" />
              <span className="text-foreground text-sm font-default font-medium">Բարձր Ճշգրտություն</span>
            </div>

            {}
            <div className="flex items-center gap-2 bg-card/80 backdrop-blur-sm px-4 py-2 rounded-md border border-border shadow-sm">
              <Languages size={16} className="text-primary" />
              <span className="text-foreground text-sm font-default font-medium">Ժամանակակից Սարքավորումներ</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}